import React from "react";
import ReactSelect, { NamedProps } from "react-select";
import StyledSelect, { selectStyles } from "./Select.styled";

const Select = (
  props: NamedProps<{ label: string; value: string }, boolean> & {
    small: boolean;
  }
) => (
  <StyledSelect>
    <ReactSelect
      isSearchable={false}
      components={{
        IndicatorSeparator: () => null,
      }}
      styles={selectStyles}
      {...props}
    />
  </StyledSelect>
);

export default Select;
